<template>

    <Card>
        <p slot="title">{{title}}</p>
        <Form ref="form" :model="model" :rules="rules" :label-width="labelWidth" @submit.native.prevent="submitEditForm">
            <slot :model="model">请在此设计表单</slot>
            <FormItem>
                <Button type="default" v-if='resetShow' @click="$refs.form.resetFields();$emit('reset')">重置</Button>
                <Button type="primary" @click="submitEditForm">{{submitBtnTxt}}</Button>
                <slot name="btn"></slot>
                <!-- <Button type="primary" html-type="submit">{{submitBtnTxt}}</Button> -->
            </FormItem>
        </Form>
    </Card>

</template>


<script>
    export default {
        name: "GenericForm",
        props: {
            model: {
                type: Object,
                required: true
            },
            rules: {
                type: Object,
                required: true
            },
            title: {
                type: String,
                default: "编辑页面"
            },
            labelWidth: {
                type: Number,
                default: 110
            },
            resetShow: {
                type: Boolean,
                default: true
            },
            submitBtnTxt: {
                type: String,
                default: "提交"
            },
        },
        data() {
            return {
                data: {}
            }
        },
        methods: {
            submitEditForm() {
                this.$refs.form.validate(valid => {
                    if (!valid) {
                        this.$Message.warning('你有内容还未填写完成,请继续填写')
                        return
                    };
                    this.$emit('submit', this.model);
                });
            }
        },
    };
</script>



// WEBPACK FOOTER //
// GenericForm.vue?50db008d